export const parsePBIMeta = strMeta => {
  if (!strMeta || strMeta === '') return null;
  return JSON.parse(strMeta);
};

export const genPBICommand = (name, title, visualId, type = 'context') => {
  const contextType = /context/gi.test(type)
    ? 'visualContextMenu'
    : 'visualOptionsMenu';

  const commandConf = {
    name: name,
    title: title,
    extend: {
      [contextType]: {
        title: title,
      },
    },
    selector: {
      $schema: 'http://powerbi.com/product/schema#visualSelector',
      visualName: visualId,
    },
  };

  return { command: commandConf };
};

export const genPBIBasicFilter = (colName, value) => ({
  filterType: 1,
  target: { table: 'VW_MAIN', column: colName },
  operator: 'In',
  values: [value],
});

export const genPBIAdvancedFilter = (
  colName,
  values,
  logicalOperator = 'And'
) => ({
  filterType: 0,
  target: { table: 'VW_MAIN', column: colName },
  logicalOperator,
  conditions: values.map(ea => ({
    operator: 'Contains',
    value: ea,
  })),
});

export const getPBIContextFilter = (companyHier, restrictions, userRestrictions) => {
  const pbiFilters = [];

  const companyLevel = companyHier.nodeLevel;

  for (let i = 1; i <= companyLevel; i++) {
    pbiFilters.push(genPBIBasicFilter(`lvl${i}_code`, companyHier[`node${i}`]));
  }

  var typeFilters = [];
  if (restrictions && restrictions.length > 0) {
    restrictions.forEach(res => {
      let filterName = '';
      switch (res.typeId) {
        case 1:
          typeFilters.push(1);
          filterName = 'CostCentre';
          break;
        case 2:
          typeFilters.push(2);
          filterName = 'Division';
          break;
        case 3:
          typeFilters.push(3);
          filterName = 'State';
          break;
        case 4:
          typeFilters.push(4);
          filterName = 'Classification';
          break;
        case 5:
          typeFilters.push(5);
          filterName = 'LeaseType';
          break;
      }

      pbiFilters.push(genPBIAdvancedFilter(filterName, res.values, 'Or'));
    });
  }
  if (userRestrictions && userRestrictions.length > 0 && userRestrictions[0].values.length > 0) {
    userRestrictions.forEach(res => {
      let filterName = '';
      switch (res.typeId) {
        case 1:
          filterName = 'CostCentre';
          break;
        case 2:
          filterName = 'Division';
          break;
        case 3:
          filterName = 'State';
          break;
        case 4:
          filterName = 'Classification';
          break;
        case 5:
          filterName = 'LeaseType';
          break;
      }
      if (typeFilters.includes(res.typeId) === false) {
        pbiFilters.push(genPBIAdvancedFilter(filterName, res.values, 'Or'));
      }
    });
  }

  return pbiFilters;
};



// WEBPACK FOOTER //
// ./src/utils/helpers/powerbi.js